// Third-party noise dropped before it reaches Sentry. Every rule pins the
// exact message, and where that message could also come from our own code,
// the vendor file that must appear in the stack — so a genuine failure of the
// same shape elsewhere still reports.

// Branch's web SDK reports this when an ad blocker refuses its script. The app
// runs without deep-link attribution, so there is nothing to act on.
export const ignoreErrors = [/^Request blocked by client, probably adblock$/];

// A script injected outside our bundle (no node_modules package ships an
// `es6/bundle`) calls composedPath on something that is not an Event.
const droppedWhenRaisedFrom = [
  {
    message: /\.composedPath is not a function\b/,
    filename: /es6\/bundle/,
  },
];

// Sentry orders chained exceptions and their frames oldest to newest, so the
// last frame of the last value is where the error was actually thrown. Only
// that frame decides: a vendor caller higher up the stack does not make an
// error raised in our own bundle third-party.
const originatingFrame = (exception) => {
  const frames = (exception.stacktrace && exception.stacktrace.frames) || [];
  return frames[frames.length - 1];
};

const raisedFrom = (exception, filename) => {
  const frame = originatingFrame(exception);
  return (
    frame !== undefined &&
    (filename.test(frame.filename || "") || filename.test(frame.abs_path || ""))
  );
};

export function isBenignThirdPartyError(event) {
  const exceptions = (event.exception && event.exception.values) || [];
  const thrown = exceptions[exceptions.length - 1];
  return (
    thrown !== undefined &&
    droppedWhenRaisedFrom.some(
      (rule) =>
        rule.message.test(thrown.value || "") &&
        raisedFrom(thrown, rule.filename)
    )
  );
}

export function beforeSend(event) {
  return isBenignThirdPartyError(event) ? null : event;
}
